<template>
  <div>
    <v-subheader>My CSAIL</v-subheader>
    <v-list-item link to="/home">
      <v-list-item-icon>
        <v-icon>mdi-account</v-icon>
      </v-list-item-icon>
      <v-list-item-title>My Account</v-list-item-title>
    </v-list-item>
    <div>
      <v-list-item link to="/equipment">
        <v-list-item-icon>
          <div v-if="lateReturn" >
            <v-icon class="red--text font-weight-medium">mdi-alert</v-icon>
          </div>
          <div v-else >
            <v-icon>mdi-desktop-tower-monitor</v-icon>
          </div>
        </v-list-item-icon>
        <v-list-item-title>My Equipment</v-list-item-title>
        <div v-if="lateReturn" class="red--text font-weight-medium">{{lateReturn}}</div>
      </v-list-item>
    </div>
    <div>
      <v-list-item link to="/keys">
        <v-list-item-icon>
          <v-icon>mdi-account-key</v-icon><!-- mdi-key -->
        </v-list-item-icon>
        <v-list-item-title>My Keys</v-list-item-title>
      </v-list-item>
    </div>
    <div v-if="featureToggleEvents">
      <v-list-item link to="/myEvents">
        <v-list-item-icon>
          <v-icon>mdi-calendar</v-icon>
        </v-list-item-icon>
      <v-list-item-title>My Events</v-list-item-title>
     </v-list-item>
    </div>
    <div v-if="featureToggleReservations">
      <v-list-item link to="/reservations/my">
        <v-list-item-icon>
          <v-icon>mdi-calendar-account</v-icon>
        </v-list-item-icon>
      <v-list-item-title>My Reservations</v-list-item-title>
     </v-list-item>
    </div>
    
    


    <v-subheader>INFORMATION</v-subheader>
    <v-list-item link to="/maps">
      <v-list-item-icon>
        <v-icon>mdi-map</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Maps</v-list-item-title>
    </v-list-item>
    <v-list-item link to="/email">
      <v-list-item-icon>
        <v-icon>mdi-email</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Email</v-list-item-title>
    </v-list-item>
    <v-list-item link to="/storage">
      <v-list-item-icon>
        <v-icon>mdi-harddisk</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Storage</v-list-item-title>
    </v-list-item>
    <v-list-item link to="/network">
      <v-list-item-icon>
        <v-icon>mdi-cloud</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Network</v-list-item-title>
    </v-list-item>
    <v-list-item link to="/computing">
      <v-list-item-icon>
        <v-icon>mdi-desktop-classic</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Computing</v-list-item-title>
    </v-list-item>
    <v-list-item link to="/documents">
      <v-list-item-icon>
        <v-icon>mdi-text-box</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Documentation</v-list-item-title>
    </v-list-item>
    <v-list-item link to="/events">
      <v-list-item-icon>
        <v-icon>mdi-calendar-text</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Events</v-list-item-title>
    </v-list-item>
  </div>
</template>

<script>
import BaseMitConfigService from '../../../base/services/BaseMitConfigService.js';
import MitEquipmentApiService from "../../services/MitEquipmentApiService.js";

export default {
  name: 'MitMenuUser',
  components: {
  },
  props: {
    userModel: Object
  },
  data() {
    return {
      featureToggleEvents:false,
      featureToggleReservations:false,
      lateReturn: null,
      mitEquipmentApiService: null
    }
  },
  mounted() {
    this.featureToggleEvents = BaseMitConfigService.getFeatureEnabled('feature-toggle-events');
    this.featureToggleReservations = BaseMitConfigService.getFeatureEnabled('feature-toggle-reservations');

    this.mitEquipmentApiService = new MitEquipmentApiService();
    this.mitEquipmentApiService.getMyReservation()
      .then((response) => {
        this.lateReturn = this.mitEquipmentApiService.LateReturn;
    });
  }

}
</script>

<style lang="scss" scoped>
</style>
